define(function(require, exports, module) {
    'use strict';

    var CashierMethodModel = require('portlets/cashier/cashier.method.model');
    var utils = require('utils');
    var i18n = require('i18n');
    var _ = require('underscore');

    module.exports = CashierMethodModel.extend({
        _prepareValidationConfig: function(data) {
            var validationConfig = data.config.validationConfig;

            data = data.code === 'VisaCheckout' ? data.account[0] : data;

            var accountFields = data.accountFields;
            var reChar = '/';
            var amount = validationConfig.amount;
            var limits, range;

            if ('amountRequired' in data) {
                amount.required = data.amountRequired
                    ? amount.required || true // may be an object
                    : false;
            }

            // for PM API
            if (accountFields) {
                accountFields.field.forEach(function(item) {
                    var validationRe = item.validation || '';
                    var opts = '';
                    var cfg = { required: Boolean(item.isRequired) };
                    var lastIdx;
                    const isIBAN = item.label.toLowerCase() === 'iban';
                    const messageTKey = isIBAN ?
                        'playtech.mobile.system.mobile-cashier.generic.iban-validation' :
                        'playtech.mobile.system.mobile-cashier.generic.regexp-validation';

                    if (validationRe) {
                        if (validationRe[0] === reChar) {
                            lastIdx = validationRe.lastIndexOf(reChar);
                            opts = validationRe.substring(lastIdx + 1);
                            validationRe = validationRe.substring(1, lastIdx);
                        }
                        validationRe = '^$|(' + validationRe + ')';
                        cfg.regexp = {
                            regexp: new RegExp(validationRe, opts),
                            message: i18n.t(messageTKey)
                        };

                        cfg.fn = {
                            fn: function($inputs, config, form) {
                                if (isIBAN) {
                                    let ibanNumber = form.$el.find('input[name="field1"]').val();
                                    let preventIban = 'CH3704835284238523000';
                                    /*  Iban number TransferWise message => A payment to a Transferwise account is not possible.
                                        Please prevent players to request withdrawals to this IBAN starting
                                        with the numbers CH8008635008770000xxx.
                                    */
                                    let preventStartsFrom = 'CH8008635008770000'; //CH8008635008770000xxx
                                    let liechtenstein = 'LI'; //LIxxxxxxxxxxxxxxxxxxx
                                    let isFoundTransferWiseAcc = ibanNumber && ibanNumber.indexOf(preventStartsFrom) !== -1;
                                    let isFoundLiechtenstein = ibanNumber && ibanNumber.indexOf(liechtenstein) !== -1;
                                    let qrString = ibanNumber.slice(4, 9);
                                    let qrIidNumber = !isNaN(qrString) && Number(qrString); // QR-IID in the digits 5 to 9 of a Swiss IBAN
                                    const patternYuhBank = /878100/;

                                    if (!isNaN(qrIidNumber) && qrIidNumber >= 30000 && qrIidNumber <= 31999) { // QR-IID from 30000 to 31999
                                        this.message = i18n.t('playtech.mobile.system.mobile-cashier.generic.iban-validation-qr-iid');
                                        return false;
                                    } else if (ibanNumber === preventIban) {
                                        this.message = i18n.t('playtech.mobile.system.mobile-cashier.generic.iban-validation-revolt');
                                        return false;
                                    } else if (patternYuhBank.test(ibanNumber)) {
                                        this.message = i18n.t('playtech.mobile.mobile-cashier.generic.iban-validation-yuh');
                                        return false;
                                    } else if (isFoundTransferWiseAcc) {
                                        this.message = i18n.t('playtech.mobile.system.mobile-cashier.generic.iban-validation-transferwise');
                                        return false;
                                    } else if (isFoundLiechtenstein) {
                                        this.message = i18n.t('playtech.mobile.system.mobile-cashier.generic.iban-validation');
                                        return false;
                                    }
                                }

                                return true;
                            }
                        };
                    }

                    validationConfig[item.name] = utils.deepExtend(cfg, validationConfig[item.name]);
                });
            }

            if (amount && amount.range) {
                limits = data.limits;
                range = amount.range;
                if (limits || range.min || range.max) {
                    if (typeof range !== 'object') {
                        range = amount.range = {};
                    }
                    if (limits) {
                        range.min = limits.min;
                        range.max = limits.max;
                    }

                } else {
                    // Do not use range validation without actual limits
                    delete amount.range;
                }
            }
        },

        findAccount: function(accountCode) {
            return _.find(this.attributes.account, function(acc) {
                return acc.code === accountCode.toString();
            });
        }
    });
});
